import React from 'react';
import {Glob as G} from "../libs/Glob.mjs";
import {
	Alert,
	Button,
	Form,
	FormGroup,
	Input, Label, ListGroup, ListGroupItem,
	Modal,
	ModalBody,
	ModalFooter,
	ModalHeader
} from "reactstrap";
import UserIcon from "../media/images/UserIcon.mjs";
import AdminUser from "./AdminUser.mjs";
import "./AdminUsersList.css";
import Select from "react-select";
import TextLabel from "../controls/TextLabel.mjs";
import UserAddIcon from "../media/images/UserAddIcon.mjs";
import CdIcon from "../media/images/CdIcon.mjs";
import appLib from "../libs/appLib.mjs";

const prefix = 'AdminUsersList';

const emailError = ( e = "" ) => {
	if ( ! e ) return false;
	return e.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/) ? false : "Email non valida";
}

const AdminUsersList = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			me: G.getUserLogin(),
			data: undefined,
			onEdit: {},
			editError: {}
		};
		this.uid = G.generateUid(prefix);
		this.toggleModal = this.toggleModal.bind(this);
		this.editValue = this.editValue.bind(this);
		this.textInput = this.textInput.bind(this);
		this.booleanInput = this.booleanInput.bind(this);
		this.makeChange = this.makeChange.bind(this);
	}
	componentDidMount() {
		G.register( this.props.dataKey, l => { this.setState({ data: l })}, this.uid);
	}
	componentWillUnmount() {
		G.deregister(this.uid);
	}
	ModalAutoFocus() {
		const selector = ('modal-dialog '+this.className).split(' ').join('.');
		const dlog = document.querySelector('.'+selector+' .modal-body');
		if ( ! dlog ) return;
		const input = dlog.querySelector('input[type="text"]:not([disabled]), input[type="password"]:not([disabled])');
		dlog.querySelectorAll('.hasFieldErrorFunction').forEach( ti => { ti.focus(); });
		if ( input ) input.focus();
	}
	toggleModal( state = false, data = {} ) {
		this.setState({ editing: state, onEdit: data, editError: {} } );
	}
	editValue( prop, value, fieldError = ()=> false ) {
		const oe = this.state.onEdit;
		const ee = this.state.editError || {};
		oe[prop] = value;
		ee[prop] = fieldError(value);
		if ( ! ee[prop] ) delete ee[prop];
		this.setState( { onEdit: oe, editError: ee } );
	}
	textInput( prop, desc ="", ...args ) {
		let type = 'text', mandatory, disabled = false, fieldError;
		args.forEach( arg => {
			switch ( typeof arg ) {
				case 'string' : switch( arg ) {
						case 'mandatory' : mandatory = "true"; break;
						case 'disabled' : disabled = true; break;
						default: type = arg;
					}
					break;
				case 'boolean': disabled = arg; break;
				case 'function': fieldError = arg; break;
				default: // nothing to do
			}
		});
		if ( type.includes('mail') && typeof fieldError === 'undefined' ) fieldError = emailError;
		if ( mandatory && typeof fieldError === 'undefined' ) fieldError = (x)=> (String(x||'').trim().length ? false : G.label('This field is mandatory'));
		if ( typeof fieldError === 'undefined' ) fieldError = ()=>false;
		return(
			<FormGroup>
				<Input
					className={ fieldError ? 'hasFieldErrorFunction' : ''}
					invalid={ !! this.state.editError[prop] }
					disabled={ disabled }
					type={type}
					mandatory={ mandatory }
					placeholder={desc}
					title={ this.state.editError[prop] || desc }
					value={this.state.onEdit[prop]||''}
					onChange={e => { this.editValue(prop, e.target.value, fieldError ) }}
					onFocus={ (e)=>{ this.editValue(prop, e.target.value, fieldError ) } }
				/>
				<Alert
					color={"danger"}
					hidden={ ! this.state.editError[prop] }
				>
					{ String(this.state.editError[prop]) }
				</Alert>
			</FormGroup>
		);
	}
	booleanInput( prop, ...args ) {
		let desc = '', disabled = false, fieldError = ()=> false;
		args.forEach( arg => {
			switch ( typeof arg ) {
				case 'string' : desc = arg; break;
				case 'boolean': disabled = arg; break;
				case 'function': fieldError = arg; break;
				default: // nothing to do
			}
		})
		const id = G.generateUid('switch');
		return(
			<FormGroup switch>
				<Input
					id={ id }
					disabled={ disabled }
					type={"switch"}
					checked={ !! this.state.onEdit[prop] }
					onChange={ () => { this.editValue(prop, ! this.state.onEdit[prop], fieldError ); }}
				/>
				<Label for={id} check>{ desc }</Label>
			</FormGroup>
		);
	}
	makeChange( endpoint, data ) {
		if ( typeof data === 'undefined' ) data = this.state.onEdit;
		G.api(
			'admin/'+endpoint,
			data
		).then( () => {
			this.props.refresh();
		}).catch( e => {
			console.error(e);
		}).finally( ()=>{
			this.toggleModal();
			appLib.clearCache();
		})
	}
	render() {
		if ( ! this.state.data ) return <p>Loading...</p>;
		const g2opts = this.state.data.groups
			.filter( g => ( g.id !== 'admin'))
			.map( g => ({ value: g.id, label: g.name }));
		return(
			<>
				<div className={prefix} id={this.uid}>
					<div className={"text-end"}>
						<Button
							color="primary"
							className="btn-icon"
							onClick={() => { this.toggleModal('newUser') }}
						>
							<i>
								<UserAddIcon/>
							</i>
							<b>
								<TextLabel value={"New user"} />
							</b>
						</Button>
					</div>
					<table className={"UsersList"}>
						<thead>
						<tr>
							<th/>
							<th>
								<TextLabel value={"Login"} />
							</th>
							<th>
								<TextLabel value={"Name"} />
							</th>
							<th>
								<TextLabel value={"Groups"} />
							</th>
							<th>
								<TextLabel value={"Email"} />
							</th>
							<th/>
						</tr>
						</thead>
						<tbody>
							{ this.state.data.users.map( u => (
									<AdminUser
										key={ u.user }
										user={ u }
										groups={ this.state.data.groups }
										change={ this.makeChange }
										editUser={ uid => {
											const udata = G.clone(this.state.data.users.find(u => u.user === uid));
											this.toggleModal('editUser', udata);
										}}
									/>
								))}
						</tbody>
					</table>
				</div>
				<Modal
					className={prefix + ' editUser'}
					isOpen={this.state.editing === 'editUser'}
					toggle={this.toggleModal}
					onOpened={ this.ModalAutoFocus }
				>
					<Form
						onSubmit={ e=>{
							e.preventDefault();
							if ( Object.keys( this.state.editError).length ) return;
							const data = { user: this.state.onEdit.user };
							if ( this.state.onEdit.name ) data.name = this.state.onEdit.name;
							if ( this.state.onEdit.mail ) data.mail = this.state.onEdit.mail;
							data.isAdmin = !! this.state.onEdit.isAdmin;
							data.isDisabled = !! this.state.onEdit.isDisabled;
							if ( this.state.onEdit.groups ) data.groups = this.state.onEdit.groups;
							if ( data.isAdmin ) delete data.groups;
							if ( this.state.onEdit.chpwd ) {
								const pwd = this.state.onEdit.pwd;
								const pwd2 = this.state.onEdit.pwd2;
								if ( pwd.length > 3 && pwd === pwd2 ) {
									data.password = pwd;
								} else {
									// error
									return;
								}
							}
							this.makeChange('editUser', data);
						}}
					>
						<ModalHeader toggle={this.toggleModal}>
							<UserIcon />
							{ this.state.onEdit.user === this.state.me
								?
								<TextLabel value={"Edit own user"} />
								:
								<TextLabel value={"Edit user"} />
							}
						</ModalHeader>
						<ModalBody>
							{ this.textInput('user', G.label('Unique login'), 'text', 'disabled') }
							<ListGroup>
								<ListGroupItem>
									{ this.textInput('name', G.label('UserNameDesc')) }
									{ this.textInput('mail', G.label('UserEmailDesc'), 'email') }
									{ this.booleanInput('isAdmin', G.label('UserIsAdminDesc'), (this.state.onEdit.user === this.state.me), v=>{
										this.editValue('groups', v ? ['admin'] : []);
										return undefined;
									}) }
									{ this.booleanInput('isDisabled', G.label('UserIsDisabledDesc'), (this.state.onEdit.user === this.state.me)) }
								</ListGroupItem>
								<ListGroupItem>
									<p>
										<TextLabel value={"Groups"} />
									</p>
									<Select
										placeholder={ G.label('SelectMulti') }
										options={g2opts}
										value={
											( this.state.onEdit.isAdmin ?
													this.state.data.groups.filter( x => x.id === 'admin') :
													(this.state.onEdit.groups || [])
											).map(g => ({
											value: g.id,
											label: g.name
										}))}
										isMulti={true}
										defaultValue={[]}
										isDisabled={!!this.state.onEdit.isAdmin}
										onChange={v => {
											this.editValue('groups', (v || []).map(g => ({
												id: g.value,
												name: g.label
											})));
										}}
									/>
								</ListGroupItem>
								<ListGroupItem>
									<p>
										<TextLabel value={"OptionalPasswordChange"} />
									</p>
									{ this.textInput('pwd', G.label('New password'), 'password', v => {
										if (!v && ! this.state.onEdit?.pwd2 ) return false;
										if (v.length < 4) return G.label('AtLeastLenChars',{len:4});
										return false;
									}) }
									{ this.textInput('pwd2', G.label('ConfirmPasswordIf'), 'password', v => {
										if (!v && ! this.state.onEdit?.pwd ) return false;
										if (v.length < 4) return G.label('AtLeastLenChars',{len:4});
										if (v !== this.state.onEdit?.pwd) return G.label("Passwords don't match");
										return false;
									}) }
								</ListGroupItem>
							</ListGroup>
						</ModalBody>
						<ModalFooter>
							<Button
								className={"btn-icon"}
								type="submit"
								color="success"
								disabled={ !! Object.keys( this.state.editError).length }
							>
								<i>
									<CdIcon/>
								</i>
								<b>
									<TextLabel value={"Save"} />
								</b>
							</Button>
						</ModalFooter>
					</Form>
				</Modal>
				<Modal
					className={prefix + ' newUser'}
					isOpen={this.state.editing === 'newUser'}
					toggle={this.toggleModal}
					onOpened={this.ModalAutoFocus }
				>
					<Form
						onSubmit={ e=>{
							e.preventDefault();
							if ( Object.keys( this.state.editError).length ) return;
							const data = { user: this.state.onEdit.user };
							if ( this.state.onEdit.name ) data.name = this.state.onEdit.name;
							if ( this.state.onEdit.mail ) data.mail = this.state.onEdit.mail;
							if ( this.state.onEdit.isAdmin ) data.isAdmin = true;
							if ( this.state.onEdit.isDisabled ) data.isDisabled = true;
							if ( this.state.onEdit.groups ) data.groups = this.state.onEdit.groups;
							if ( data.isAdmin ) delete data.groups;
							const pwd = this.state.onEdit.pwd;
							const pwd2 = this.state.onEdit.pwd2;
							if ( pwd.length > 3 && pwd === pwd2 ) {
								data.password = pwd;
							} else {
								return;
							}
							this.makeChange('editUser', data);
						}}
					>
						<ModalHeader toggle={this.toggleModal}>
							<UserAddIcon />
							<TextLabel value={"New user"} />
						</ModalHeader>
						<ModalBody>
							<ListGroup>
								<ListGroupItem>
									{this.textInput('user', G.label('Unique login'), v => {
										if (!v) return G.label('This field is mandatory');
										if (v.length < 4) return G.label('AtLeastLenChars',{len:4});
										if (this.state.data.users.find(u => u.user === v)) return G.label('User already exists');
										return false;
									})}
								</ListGroupItem>
								<ListGroupItem>
									<p>
										<TextLabel value={"Password"} />
									</p>
									{this.textInput('pwd', G.label('Password'), 'mandatory', (v) => {
										if (!v) return G.label('This field is mandatory');
										if (v.length < 4) return G.label('AtLeastLenChars',{len:4});
										return false;
									})}
									{this.textInput('pwd2', G.label('Confirm password'), 'mandatory', v => {
										if (!v) return G.label('This field is mandatory');
										if (v.length < 4) return G.label('AtLeastLenChars',{len:4});
										if (v !== this.state.onEdit?.pwd) return G.label("Passwords don't match");
										return false;
									})}
								</ListGroupItem>
								<ListGroupItem>
									{this.textInput('name', G.label('UserNameDesc'))}
									{this.textInput('mail', G.label('UserEmailDesc'), 'email')}
									{this.booleanInput('isAdmin', G.label('UserIsAdminDesc'), v => {
										if (v) this.editValue('groups', []);
										return false;
									})}
									{this.booleanInput('isDisabled', G.label('UserIsDisabledDesc'))}
								</ListGroupItem>
								<ListGroupItem>
									<p>
										<TextLabel value={"Groups"} />
									</p>
									<Select
										placeholder={G.label('SelectMulti')}
										options={g2opts}
										value={(this.state.onEdit.groups || []).map(g => ({
											value: g.id,
											label: g.name
										}))}
										isMulti={true}
										defaultValue={[]}
										isDisabled={!!this.state.onEdit.isAdmin}
										onChange={v => {
											this.editValue('groups', (v || []).map(g => ({
												id: g.value,
												name: g.label
											})));
										}}
									/>
								</ListGroupItem>
							</ListGroup>
						</ModalBody>
						<ModalFooter>
							<Button
								className={"btn-icon"}
								type="submit"
								color="success"
								disabled={ !! Object.keys( this.state.editError).length }
							>
								<i>
									<CdIcon/>
								</i>
								<b>
									<TextLabel value={"Save"} />
								</b>
							</Button>
						</ModalFooter>
					</Form>
				</Modal>
			</>
		)
	}
}

export default AdminUsersList;
